export default "__VITE_ASSET__B3z3qAXo__"